<template>
	
	<div class="aboutDetailPage">
		
		<hxlHeader />
		<div class="containter w1200">
			<img v-if="type === '1'" src="./images/1.png" alt="" />
            <div v-if="type === '2'" class="type2">
                <h1>法律规则</h1>
                <p>任何人进入、浏览和使用缩水网(6.36886.net)网站即承认已阅读、理解并同意受本使用条款约束，并遵守所有适用的法律和法规。 若您不同意遵从本使用条款，请勿使用缩水网(以下简称"本网站")。缩水网有权随时更新本使用条款，您将受到更新后的使用条款的约束， 因此您应经常地访问并了解本网站的使用条款。</p>
                <p><span>★</span>使用限制</p>
                <p>本网站提供的任何内容(包括但不限于数据、文字、图表、图象、声音或录象等)的版权均属于彩运网或相关权利人。未经缩水网或相关权利人事先的书面许可，您不得以任何方式擅自复制、再造、传播、出版、转帖、改编或陈列本网站的内容。同时，未经缩水网书面许 可，对于本网站上的任何内容，任何人不得在非缩水网所属的服务器上做镜像。任何未经授权使用本网站的行为都将违反《中华人民共和国著作权法》和其他法律法规以及有关国际公约的规定。</p>
                <p><span>★</span>内容的改变</p>
                <p>缩水网有权随时改变和更新本网站上的内容，不需要先行通知您本人。</p>
                <p><span>★</span>不担保声明</p>
                <P>缩水网不能保证在任何时候、网站上的所有内容均正确、及时和完整缩水网以及其分支机构、员工、代理以及其他任何代表(以下简称"相关人")对于本网站内容的任何错误、不准确和遗漏以及使用本网站内容得出的结果都将不承担任何责任。缩水网及相关人不能保证您任 何时候均可进入、浏览和使用本网站，对本网站和其内容的不能使用和使用错误不承担任何责任。</P>
                <p><span>★</span>隐私保护</p>
                <p>保护用户隐私是缩水网的一项基本政策。缩水网不会公布或传播您在本网站注册的任何资料，但下列情况除外:1)事先获得用户的明确授权;2)根据有关法律法规的要求;3)依据法院或仲裁机构的裁判或裁决，以及其他司法程序的要求;4)按照相关政府主管部门的要求;5)用户违反使用条款的规定或有其他损害传奇彩运网利益的行为。</p>
                <p><span>★</span>免责声明</p>
                <p>任何情况下，缩水网及相关人对于进入或使用本网站引起的任何依赖本网站内容而作出的决定或采取的行动不承担任何责任，对进入或使用本网站而产生的任何直接的、间接的、惩罚性的损失或其他任何形式的损失包括但不限于业务中断、数据丢失或利润损失不承担任何责任，即使缩水网被明确告知可能会发生上述损失。缩水网以及相关人对于您在进入、浏览和使用本网站或从本网站下载任何内容而导致病毒或其他破坏性程序对您的电脑系统以及其他任何软件、硬件、IT系统或财产的损害或损失不承担任何责任。</p>
                <p><span>★</span>意见及网上论坛</p>
                <p>本网站表述的任何意见均属于作者个人意见，并不代表缩水网运营商或缩水网关联公司的意见。</p>
                <p><span>★</span>其他网站的链接</p>
                <p>缩水网对您通过本网站的链接而进入其他网站不承担任何责任。当您进入其他网站时，您已充分理解这些网站与缩水网是无关的，并且也不在缩水网的控制范围内。另外，本网站对其他网站的链接本身并不表示缩水网认可或承担其他网站内容或使用上的责任。您应谨慎地进入其他网站以免遭病毒或其他破坏性程序的侵害。</p>
                <p><span>★</span>法律适用和管辖</p>
                <p>本网站及使用条款，应适用中华人民共和国法律。任何有关本网站和使用条款的争议，应由缩水网平台当地的法院管辖。</p>
            </div>
			<img v-if="type === '3'" src="./images/3.png" alt="" style="width: 50%;"/>
			<img v-if="type === '4'" src="./images/4.png" alt="" />
			<img v-if="type === '5'" src="./images/5.png" alt="" style="width: 70%;"/>
		</div>
		

        <hxlFooder />
	</div>
</template>

<script>
	import hxlHeader from "@/views/common/header.vue";
	import hxlFooder from "@/views/common/fooder.vue";
	export default {
		components: {
			hxlHeader,
			hxlFooder,
		},
		data() {
			return {
				type: this.$route.query.type
			};
		}
	}
</script>

<style lang="scss" scoped>
	.containter{
		img{
			max-width: 90%;display: block;
		}
        .type2{
            p{
                text-indent: 2em;
                line-height: 2em;
                font-size: 16px;
                span{
                    margin-right: 5px;
                    color: red;
                }
            }
        }
	}
</style>
